/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaEtapasVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaEtapas: React.FunctionComponent<ITablaEtapasVistaProps & InjectedIntlProps> = ({
    etapass,
    cargarEtapas,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={etapass}
            actions={acciones(manejarFormulario, cargarEtapas, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaEtapas);
